import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActiveTabState {
  [type: string]: boolean;
}

const initialState: ActiveTabState = {};

const Status = createSlice({
  name: 'ActiveTabStt',
  initialState,
  reducers: {
    Active: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = true;
    },
    UnActive: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = false;
    },
  },
});

export const { Active, UnActive } = Status.actions;
export default Status.reducer;
